import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationTobaPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationToba,
);
